"use strict";
// Trignometry Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#trigonometry-expression-operators
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrignometryOperator = void 0;
var core_1 = require("../../../core");
var util_1 = require("../../../util");
/**
 * Returns an operator for a given trignometric function
 *
 * @param f The trignometric function
 */
function createTrignometryOperator(f, returnInfinity) {
    return function (obj, expr, options) {
        var n = (0, core_1.computeValue)(obj, expr, null, options);
        if (isNaN(n) || (0, util_1.isNil)(n))
            return n;
        if (n === Infinity || n === -Infinity) {
            if (returnInfinity)
                return n;
            throw new Error("cannot apply $" + f.name + " to -inf, value must in (-inf,inf)");
        }
        return f(n);
    };
}
exports.createTrignometryOperator = createTrignometryOperator;
